import { render, staticRenderFns } from "./MainGame.vue?vue&type=template&id=57d7357a&scoped=true&"
import script from "./MainGame.vue?vue&type=script&lang=js&"
export * from "./MainGame.vue?vue&type=script&lang=js&"
import style0 from "./MainGame.vue?vue&type=style&index=0&id=57d7357a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_y5o36p7qrshhm4v7l6yk7rwfsu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d7357a",
  null
  
)

export default component.exports